import React from "react";

// Shown in place of an SSP finance screen that now lives on finance.more.in. The payment, DN, JV and
// receipt screens posted to Oracle Fusion (retired 31-Aug-2026); the six non-merch screens (PO
// Creation / Approval, Invoice Upload, Service GRN, Edit GRN, Approve Invoice) were switched off on
// 14-Oct-2026 once the Non-merch PO and Non-merch Bills modules were confirmed by finance. The routes
// stay only so the sidebar links land on this pointer instead of a blank page.
const MovedToFinance = ({ screen, target, path }) => (
  <div style={{ maxWidth: 560, margin: "80px auto", padding: 32, border: "1px solid #E4EAF0", borderRadius: 12, fontFamily: "inherit", color: "#172128" }}>
    <h2 style={{ margin: "0 0 12px", fontSize: 22 }}>{screen} has moved</h2>
    <p style={{ margin: "0 0 20px", lineHeight: 1.5, color: "#808C96" }}>
      This SSP screen is retired. {screen} is now done on finance.more.in under <b>{target}</b>.
    </p>
    <a
      href={`https://finance.more.in/dashboard/${path}`}
      style={{ display: "inline-block", padding: "10px 18px", background: "#FA4B16", color: "#FFFFFF", borderRadius: 8, textDecoration: "none", fontWeight: 600 }}
    >
      Open {target}
    </a>
  </div>
);

export default MovedToFinance;
